<template>
  <div>
    <div class="navigation">
      <div class="minbox">执业药师继续教育登录入口</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "navigation",
};
</script>

<style lang="less" scoped>
.navigation {
  width: 100%;
  height: 100px;
  background: #2aa9b5;
  .minbox {
    width: 1200px;
    margin: auto;
    height: 100px;
    background: #2aa9b5;
    font-size: 17px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 100px;
  }
}
</style>
